module.exports = __webpack_public_path__ + "img/product_express_inactive_mobile.d3bd7e7a.png";